import React, { useState } from 'react'
// import xmlToJson from 'simple-xml-to-json'
import { XMLParser } from 'fast-xml-parser'
import { FileUploader } from 'react-drag-drop-files'
import { Box, Button, CircularProgress, Dialog, TextField } from '@mui/material'
import { useSnackbar } from 'notistack'
import { getCookie } from '../Utils/CookieHelper'
import Service from '../Networking/NetworkingUtils'

var token = getCookie("bb_metaverse_token");


const Xmltojson = (props) => {
  const [xml, setXml] = useState(null)
  const [disabled, setDisabled] = useState(false)
  const { enqueueSnackbar } = useSnackbar();
  const [versionName, setVersionName] = useState('')
  const [versionDescription, setVersionDescription] = useState('')

  const handleFileChange = (file) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      setXml(e.target.result)
    }
    reader.readAsText(file)
  }

  // const handleConvert = () => {
  //   try {
  //     const parser = new XMLParser()
  //     const result = parser.parse(xml)
  //   } catch (e) {
  //   }
  // }

  const uploadProgram = () => {
    if (versionName.length === 0) {
      enqueueSnackbar('Please enter version name!', {
        variant: 'warning'
      });
      return
    }
    if (versionDescription.length === 0) {
      enqueueSnackbar('Please enter version description!', {
        variant: 'warning'
      });
      return
    }
    if(!xml){
      enqueueSnackbar('Please upload an XML file!', {
        variant: 'warning'
      });
      return
    }
    try {
      setDisabled(true)
      const parser = new XMLParser()
      const result = parser.parse(xml)
      result.program_directory = props.programDirectory.id
      result.version_name = versionName
      result.version_description = versionDescription
      if (result) {
        Service.post(`/api/program/schedule/create_program_wbs_and_activity/`, {
          headers: {
            Authorization: "Token " + token,
          },
          data: result,
        })
          .then(res => {
            setDisabled(false)
            if(props.close){
              props.close()
            }
            enqueueSnackbar('Program uploaded successfully!', {
              variant: 'success'
            });
          })
          .catch(error => {
            console.log(error)
            setDisabled(false)
            enqueueSnackbar('Something went wrong!', {
              variant: 'error'
            });
          });
      }
    } catch (e) {
      setDisabled(false)
      enqueueSnackbar('Please convert valid XML to JSON before uploading!', {
        variant: 'warning'
      });
    }
  }

  return (
    <div>
      <Box display="flex" flexDirection={'column'} alignItems="center" width='100%'>
        <Box mt={2}>
          <TextField
            label="Version Name"
            value={versionName}
            fullWidth
            sx={{width: 330}}
            onChange={(e) => setVersionName(e.target.value)}
          />
        </Box>
        <Box mt={2}>
          <TextField
            label="Version Description"
            value={versionDescription}
            fullWidth
            sx={{width: 330}}
            onChange={(e) => setVersionDescription(e.target.value)}
          />
        </Box>
        <Box mt={2}>
        <FileUploader
          handleChange={handleFileChange}
          types={["xml"]}
          label="Drag & drop or click to upload XML file"
        />
        </Box>
        <br />
        {/* <Button color='primary' variant='contained' size='small' onClick={handleConvert}>Convert to JSON</Button>
      {json &&
        <Button color='secondary' variant='contained' size='small' style={{ marginLeft: 8 }} onClick={handleDownload}>
          Download JSON
        </Button>
      } */}
        {/* <pre>{json ? JSON.stringify(json, null, 2) : ''}</pre> */}
      </Box>
      <Box display={'flex'} width={'100%'} alignItems={'center'} justifyContent={'flex-end'}>
        <Button disabled={disabled} size='small' color='primary' variant='contained' onClick={() => uploadProgram()}>Upload</Button>
      </Box>
      <Dialog maxWidth="xs" open={disabled}>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} p={4}>
          <CircularProgress />
        </Box>
      </Dialog>
    </div>
  )
}

export default Xmltojson